import React from 'react';

import {SvgProps} from '../../helpers/type';

const Lift = ({className}: SvgProps): JSX.Element => {
    return (
        <svg
            width="28"
            height="29"
            viewBox="0 0 28 29"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            className={className}
        >
            <path d="M7.33331 12.3334H3.33331V21.6667H7.33331V12.3334Z" fill="#174943" />
            <path d="M16 12.3334H12V21.6667H16V12.3334Z" fill="#174943" />
            <path d="M27.3333 24.3334H0.666656V28.3334H27.3333V24.3334Z" fill="#174943" />
            <path d="M24.6667 12.3334H20.6667V21.6667H24.6667V12.3334Z" fill="#174943" />
            <path d="M14 0.333374L0.666656 7.00004V9.66671H27.3333V7.00004L14 0.333374Z" fill="#174943" />
        </svg>
    );
};

export default Lift;
